module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/background-top-shadow-8e59d583c0e665c22b194f94f0cf1736.png";